if (!process.env.NEXT_PUBLIC_API_URL) throw new Error('API_URL env variable is missing')

/** The base remote API URL */
export const baseRemoteAPIURL = process.env.NEXT_PUBLIC_API_URL

/** The base local API URL */
export const baseLocalAPIURL = '/api'